/* eslint-disable max-len */
import 'react';

const EditSvg2 = (): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 14 14"
        fill="currentColor"
    >
        <g fillRule="evenodd">
            <g>
                <path d="M8.262 3.022l2.036 2.036a.72.72 0 010 1.018l-5.134 5.135a.72.72 0 01-.51.211H2.618a.72.72 0 01-.72-.72V8.666a.72.72 0 01.21-.51l5.136-5.134a.72.72 0 011.018 0zM10.298.985l2.037 2.037a.72.72 0 010 1.018l-.51.509a.72.72 0 01-1.018 0L8.771 2.513a.72.72 0 010-1.019l.51-.509a.72.72 0 011.017 0zM8.213 10.068h4.32a.72.72 0 110 1.44h-4.32a.72.72 0 010-1.44z" />
            </g>
        </g>
    </svg>
);
export default EditSvg2;
